import React from "react";

export default function Error404Page() {
  return <h1>Error404</h1>;
}
